import React from 'react'

export const BlacklistActionsColors = {
  DESBLOQUEIO: '#81c784',
  DESBLOQUEIO_DARK: '#388e3c',
  BLOQUEIO: '#e57373',
  BLOQUEIO_DARK: '#e53935'
}

export function BlacklistBadgeStatus({ status, label }) {
  return (
    <div
      style={{
        padding: 10,
        borderRadius: 10,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        backgroundColor: BlacklistActionsColors[status],
        textAlign: 'center',
        lineHeight: '100%'
      }}
    >
      {label}
    </div>
  )
}
